import { apiGet } from '@/store/api';
import { usePortcallStore } from '@/store/portcallStore';

export async function getCargoItems(callId: string | number) {
  const result = await apiGet(`cargo/call/${callId}`);
  usePortcallStore().setCargo(result);
}
